import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { Stack } from "@volca/ui/components/ui/stack";
import type { AiSpreadsheetValueType } from "@/payroll/ai-script/types";
import { CELL_FORMAT_OPTIONS } from "./cell-format-options";
import { ToolbarSegment } from "./toolbar-segment";

interface CellFormatMenuProps {
  valueType?: string | null;
  onFormatChange?: (valueType: AiSpreadsheetValueType) => void;
}

export const CellFormatMenu = ({
  valueType,
  onFormatChange,
}: CellFormatMenuProps) => {
  const currentFormat = CELL_FORMAT_OPTIONS.find(
    (option) => option.value === valueType,
  );
  if (!currentFormat) return null;

  if (!onFormatChange) {
    return (
      <Stack
        direction="row"
        align="center"
        gap={1}
        className="shrink-0 border-l border-line px-3 text-sm text-subtle"
      >
        {currentFormat.icon}
      </Stack>
    );
  }

  return (
    <ToolbarSegment>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              size="sm"
              aria-label={`Cell format: ${currentFormat.label}`}
            />
          }
        >
          {currentFormat.icon}
          <CaretDownIcon />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-max">
          {CELL_FORMAT_OPTIONS.map((option) => (
            <DropdownMenuItem
              key={option.value}
              className="gap-2"
              onClick={() => onFormatChange(option.value)}
            >
              {option.icon}
              {option.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </ToolbarSegment>
  );
};
